<template>
  <svg
    tabindex="0"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    width="21"
    height="18"
    viewBox="0 0 21 18"
    @click="emmitClick"
    @keyup="emmitClick"
  >
    <g
      id="Symbols"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <!-- eslint-disable-next-line -->
        <path fill="#ffffff" d="M19,2 L10,2 L10,6 L8,6 L8,0 L10,0 L19,0 L21,-3.55271368e-15 L21,16 L21,18 L10,18 L8,18 L8,12 L10,12 L10,16 L19,16 L19,2 Z M6.41,5.41 L3.83,8 L13.5,8 L13.5,10 L3.83,10 L6.41,12.59 L5,14 L0,9 L5,4 L6.41,5.41 Z" id="Combined-Shape" transform="translate(10.500000, 9.000000) rotate(180.000000) translate(-10.500000, -9.000000) "></path>
    </g>
  </svg>
</template>

<script>

export default {
  name: 'RareIconDownload',
  methods: {
    emmitClick() {
      this.$emit('emmitClick');
    },
  },
};
</script>

<style lang="scss" scoped>

  @import "~@/css/global.scss";

  svg:hover path {
    cursor: pointer;
    fill: $green-highlight;
  }

  svg:hover {
    cursor: pointer;
  }

</style>
